<template>
  <v-dialog v-model="addPermitDialog" scrollable max-width="500px" persistent>
    <v-card>
      <v-toolbar color="white" fixed>
        <h3>{{ $i18n.t(label) }}</h3>
      </v-toolbar>
      <v-card-text>
        <v-container dense>
          <v-form v-model="isValid" ref="form">
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  v-model="newPermit.type"
                  :label="$i18n.t('Name') + '*'"
                  :rules="validationrules.type"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-btn
                  color="success darken-1"
                  @click="savePermit()"
                  :loading="addPermitLoading"
                  :disabled="!isValid"
                >Save</v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-row>
            <v-simple-table dense style="width:100%;">
              <template>
                <thead>
                  <tr>
                    <th class="text-left">{{ $i18n.t("Name") }}</th>
                    <th class="text-right"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in permits" :key="index">
                    <td>
                      <span v-show="!item.edit">{{item.type}}</span>
                      <span v-show="item.edit">
                        <v-text-field v-model="item.type"></v-text-field>
                      </span>
                    </td>
                    <td>
                      <v-btn
                        v-show="item.edit"
                        class="float-right"
                        color="green"
                        x-small
                        fab
                        text
                        :loading="addPermitLoading"
                        @click="saveOld(item);"
                      >
                        <v-icon>mdi-content-save</v-icon>
                      </v-btn>

                      <z-confirm-button
                        v-show="!item.edit"
                        class="float-right"
                        color="red lighten-1"
                        x-small
                        fab
                        text
                        :loading="addPermitLoading"
                        :message="$i18n.t('Do you want to delete this Permit ?')"
                        @click="deletePermitType(item)"
                      >
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </z-confirm-button>

                      <v-btn
                        v-show="!item.edit"
                        class="float-right"
                        color="blue"
                        x-small
                        fab
                        text
                        @click="item.edit = true;"
                      >
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <small>*indicates required field</small>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closePermitDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doPost, doGet } from "@/store/common/module/apis";

@Component({
  name: "PermitAdd",
  props: {
    showDialog: {
      default: false,
    },
    label: {
      default: "Add Permit",
    },
    refreshPermits: {
      default: false,
    },
  },
})
export default class PermitAdd extends Vue {
  addPermitDialog = false;
  isValid = true;
  newPermit = {};
  addPermitLoading = false;
  permits = [];

  hideMe() {
    this.$emit("dialogUpdate", false);
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.addPermitDialog = val;
    if (this.addPermitDialog) this.getPermits();
  }

  closePermitDialog() {
    this.$emit("closePermitDialog", false);
  }

  select(data) {
    this.$emit("select", data);
  }

  validationrules = {
    type: [(v) => !!v || this.$i18n.t("Name is required")],
  };

  async getPermits() {
    try {
      const permits = await doGet("/api/permit/type/all");
      for (let index = 0; index < permits.length; index++) {
        permits[index].edit = false;
      }
      this.permits = permits;
    } catch (e) {
      common.setError(e.message);
    }
  }

  async saveOld(_permit) {
    try {
      this.addPermitLoading = true;
      common.setLoading(true);
      await doPost("/api/permit/type/save", _permit);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      this.getPermits();
      this.newPermit = {};
      this.addPermitLoading = false;
      this.refreshPermits(true);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
      this.addPermitLoading = false;
    }
  }

  async savePermit() {
    try {
      this.addPermitLoading = true;
      common.setLoading(true);
      this.newPermit = await doPost("/api/permit/type/save", this.newPermit);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      this.getPermits();
      this.newPermit = {};
      this.addPermitLoading = false;
      this.refreshPermits(true);
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
      this.addPermitLoading = false;
    }
  }

  async deletePermitType(permit) {
    common.setLoading(true);
    try {
      await doGet("/api/permit/type/" + permit._id + "/delete");
      common.showMessage("Deleted Successfully");
      this.getPermits();
      this.refreshPermits(true);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }
}
</script>
